import { FETCH_STUDIO_APP_CONF_HAS_ERRORED, FETCH_STUDIO_APP_CONF_IS_LOADING, FETCH_STUDIO_APP_CONF_SUCCESS } from './actionTypes';

import RestService from '../RestService';
import { StudioAppConfig } from 'glance-datatypes';

export function itemsHasErrored(bool) {
    return {
        type: FETCH_STUDIO_APP_CONF_HAS_ERRORED,
    };
}
export function itemsIsLoading(bool) {
    return {
        type: FETCH_STUDIO_APP_CONF_IS_LOADING,
    };
}
export function itemsFetchDataSuccess(conf) {
    return {
        type: FETCH_STUDIO_APP_CONF_SUCCESS,
        studioAppConfig: conf,
    };
}

export function fetchStudioAppConfig() {
    return (dispatch) => {
        dispatch(itemsIsLoading(true));
        try {
            RestService.getStudioAppConfig((conf: StudioAppConfig) => {
                dispatch(itemsIsLoading(false));

                dispatch(itemsFetchDataSuccess(conf))
            });
        }
        catch(err) {
            dispatch(itemsHasErrored(true))
        }
    }
}



// WEBPACK FOOTER //
// ./src/actions/draftsAction.ts